/**
 * @generated SignedSource<<cafa6198785ad6b2e64ce3523cd345b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type WorkspaceInviteStatus = "ACCEPTED" | "EXPIRED" | "PENDING" | "REVOKED" | "%future added value";
export type WorkspaceRole = "ADMIN" | "MEMBER" | "OWNER" | "%future added value";
export type WorkspaceMembersPageInviteMutation$variables = {
  email: string;
  role?: WorkspaceRole | null | undefined;
  workspaceId: string;
};
export type WorkspaceMembersPageInviteMutation$data = {
  readonly createWorkspaceInvite: {
    readonly email: string;
    readonly expiresAt: string;
    readonly id: string;
    readonly status: WorkspaceInviteStatus;
  };
};
export type WorkspaceMembersPageInviteMutation = {
  response: WorkspaceMembersPageInviteMutation$data;
  variables: WorkspaceMembersPageInviteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "email"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "role"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      },
      {
        "kind": "Variable",
        "name": "role",
        "variableName": "role"
      },
      {
        "kind": "Variable",
        "name": "workspaceId",
        "variableName": "workspaceId"
      }
    ],
    "concreteType": "WorkspaceInvite",
    "kind": "LinkedField",
    "name": "createWorkspaceInvite",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expiresAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceMembersPageInviteMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceMembersPageInviteMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "e7507c5fa8903444b92cfff60d77a163",
    "id": null,
    "metadata": {},
    "name": "WorkspaceMembersPageInviteMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceMembersPageInviteMutation(\n  $workspaceId: ID!\n  $email: String!\n  $role: WorkspaceRole\n) {\n  createWorkspaceInvite(workspaceId: $workspaceId, email: $email, role: $role) {\n    id\n    email\n    status\n    expiresAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "391a4f9694b785fdf15124c524350c59";

export default node;
